import * as React from 'react';
const EditIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.91675 17.5H17.9167" stroke="currentColor" strokeWidth="1.5" strokeWinecap="round" strokeWinejoin="round"/>
    <path d="M4.58325 11.1333V14.1667H7.63209L16.2499 5.54504L13.2062 2.5L4.58325 11.1333Z" stroke="currentColor" strokeWidth="1.5" strokeWinejoin="round"/>
  </svg>
);
export default EditIcon;
